@if(loadingState.loading) {
  <app-loading-indication
    displayText="Lade Benutzer..."
    size="large"
  ></app-loading-indication>
} @else {
  <form [formGroup]="managedUserForm" (ngSubmit)="onSubmit()" class="user-form">
    <div class="flex flex-col gap-4">
      <div class="profile-picture-section mb-6 flex flex-col items-center">
        <div
          class="profile-picture-container cursor-pointer relative mb-2"
          (click)="!isUploading && triggerFileInput()"
          tabindex="0"
          role="button"
          (keyup.enter)="!isUploading && triggerFileInput()"
        [class.has-image]="
          managedUserForm.get('profilePictureUrl')?.value ||
          temporaryImagePreview
        "
          [class.uploading]="isUploading"
          >
          @if(managedUserForm.get('profilePictureUrl')?.value ||
            temporaryImagePreview) {
            <img
          [src]="
            managedUserForm.get('profilePictureUrl')?.value ||
            temporaryImagePreview
          "
              alt="Profile picture"
              class="rounded-full w-32 h-32 object-cover"
              />
          } @else {
            <div
              class="placeholder-circle rounded-full w-32 h-32 bg-gray-200 flex items-center justify-center"
              >
              <span class="material-symbols-outlined text-4xl text-gray-400"
                >person</span
                >
              </div>
              } @if(!isUploading) {
              <div
                class="upload-overlay absolute inset-0 rounded-full flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity"
                >
                <span class="material-symbols-outlined text-white">photo_camera</span>
              </div>
            } @else {
              <div
                class="upload-overlay absolute inset-0 rounded-full flex items-center justify-center bg-black bg-opacity-50 opacity-100"
                >
                <span class="material-symbols-outlined text-white animate-spin"
                  >sync</span
                  >
                </div>
              }
            </div>
            <input
              #fileInput
              type="file"
              accept="image/*"
              (change)="onFileSelected($event)"
              class="hidden"
              [disabled]="isUploading"
              />
            <p class="text-sm text-gray-600">
              @if(isUploading) { Bild wird hochgeladen... } @if(!isUploading &&
                pendingProfilePicture) { Bild wird nach dem Speichern hochgeladen... }
                @if(!isUploading && !pendingProfilePicture) { Klicke um ein Profilbild
                  hochzuladen }
                </p>
              </div>

              <div class="flex flex-col md:flex-row md:gap-4">
                <div class="w-full">
                  <mat-form-field class="w-full">
                    <mat-label>Vorname</mat-label>
                    <input
                      matInput
                      formControlName="firstName"
                      placeholder="Vorname eingeben"
                      />
                    @if (managedUserForm.get('firstName')?.errors?.['required']) {
                      <mat-error
                        >
                        Vorname ist erforderlich
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="w-full">
                  <mat-form-field class="w-full">
                    <mat-label>Nachname</mat-label>
                    <input
                      matInput
                      formControlName="lastName"
                      placeholder="Nachname eingeben"
                      />
                    @if (managedUserForm.get('lastName')?.errors?.['required']) {
                      <mat-error
                        >
                        Nachname ist erforderlich
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row md:gap-4">
                <div class="w-full">
                  <mat-form-field class="w-full">
                    <mat-label>Geschlecht</mat-label>
                    <mat-select formControlName="gender">
                      <mat-option value="male">Männlich</mat-option>
                      <mat-option value="female">Weiblich</mat-option>
                      <mat-option value="diverse">Divers</mat-option>
                      <mat-option value="other">Keine Angabe</mat-option>
                    </mat-select>
                    @if (managedUserForm.get('gender')?.errors?.['required']) {
                      <mat-error
                        >
                        Geschlecht ist erforderlich
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="w-full">
                  <mat-form-field class="w-full">
                    <mat-label>Geburtsjahr</mat-label>
                    <input
                      matInput
                      formControlName="birthYear"
                      type="number"
                      placeholder="Geburtsjahr eingeben"
                      class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      />
                    @if (managedUserForm.get('birthYear')?.errors?.['min'] || managedUserForm.get('birthYear')?.errors?.['max']) {
                      <mat-error
                        >
                        Bitte geben Sie ein gültiges Geburtsjahr ein
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <div class="form-group">
                <mat-form-field class="w-1/2">
                  <mat-label>PLZ</mat-label>
                  <input matInput formControlName="zipCode" placeholder="PLZ eingeben" />
                  @if (managedUserForm.get('zipCode')?.errors?.['pattern']) {
                    <mat-error>
                      Bitte geben Sie eine gültige PLZ ein
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="w-full mb-4">
                <mat-form-field class="w-full">
                  <mat-label>Kategorien</mat-label>
                  <mat-select formControlName="categories" multiple>
                    @for (category of categories; track category) {
                      <mat-option [value]="category.id">
                        {{ category.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (categoriesControl?.errors?.['required']) {
                    <mat-error>
                      Bitte wählen Sie mindestens eine Kategorie aus
                    </mat-error>
                  }
                </mat-form-field>

                <div class="selected-categories flex flex-wrap gap-2 mt-2">
                  @if (categoriesControl?.value?.length) {
                    <mat-chip-set>
                      @for (categoryId of categoriesControl?.value; track categoryId) {
                        <mat-chip>
                          {{ getCategoryName(categoryId) }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  }
                </div>
              </div>

              <div class="flex gap-2">
                <button
                  class="button-blue"
                  type="submit"
                  [disabled]="!managedUserForm.valid || loadingState.saving"
                  >
                  @if(loadingState.saving) {
                    <span class="animate-pulse">Lade ...</span>
                  } @else {
                    {{ user ? "Person aktualisieren" : "Person erstellen" }}
                  }
                </button>

                @if(user) {
                  <button
                    type="button"
                    class="bg-gray-500 text-white py-2 px-4 rounded-full hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    [disabled]="loadingState.deleting"
                    (click)="deleteUser()"
                    >
                    @if(loadingState.deleting) {
                      <span class="animate-pulse">Lösche ...</span>
                    } @else {
                      <span class="flex items-center">
                        <mat-icon class="mr-2">delete</mat-icon>
                        Person löschen
                      </span>
                    }
                  </button>
                }
              </div>
            </div>
          </form>

          <dialog #deleteDialog class="rounded-lg shadow-xl p-6 backdrop:bg-gray-950/50">
            <div class="flex flex-col gap-4">
              <h2 class="text-xl font-semibold">Person löschen</h2>
              <p>
                Sind Sie sicher, dass Sie diese Person löschen möchten? Diese Aktion kann
                nicht rückgängig gemacht werden.
              </p>

              <div class="flex justify-end gap-4 mt-4">
                <button
                  class="bg-gray-500 text-white py-2 px-4 rounded-full hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                  type="button"
                  [disabled]="loadingState.deleting"
                  (click)="cancelDelete()"
                  >
                  Abbrechen
                </button>
                <button
                  class="bg-blue-500 text-white py-2 px-4 rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                  type="button"
                  [disabled]="loadingState.deleting"
                  (click)="confirmDelete()"
                  >
                  @if(loadingState.deleting) {
                    <span class="animate-pulse">Lösche ...</span>
                  } @else {
                    <span class="flex items-center">
                      <mat-icon class="mr-2">delete_forever</mat-icon>
                      Endgültig löschen
                    </span>
                  }
                </button>
              </div>
            </div>
          </dialog>
        }
